import React from 'react'
import { Box } from '@workwhile/ui'
import { IndeedFlexAuthStatusBanner } from 'pages/IndeedFlex/shared/components/IndeedFlexAuthStatusBanner'
import { IndeedFlexJobShiftsHeader } from './IndeedFlexJobShiftsHeader'
import { IndeedFlexJobShiftsFilterBar } from './IndeedFlexJobShiftsFilterBar'
import { IndeedFlexJobShiftsCards } from './IndeedFlexJobShiftsCards'

export const IndeedFlexJobShiftsMain = () => {
  return (
    <>
      <IndeedFlexJobShiftsHeader />
      <IndeedFlexAuthStatusBanner />
      <IndeedFlexJobShiftsFilterBar />
      <Box margin={3}>
        <IndeedFlexJobShiftsCards />
      </Box>
    </>
  )
}
